module.exports = __webpack_public_path__ + "static/img/Epsilon-Default.0c8c483.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/dataSources/Epsilon-Default.png
// module id = 1566
// module chunks = 0